import {Injectable} from "@angular/core";
import {BehaviorSubject, Observable} from "rxjs";

export class AudioTranscriptionService {

    transcription$: Observable<string> = new BehaviorSubject(undefined);
    transcriptionInProgress$: Observable<boolean> = new BehaviorSubject(false);

    setTranscription(transcription: string) {
        (this.transcription$ as BehaviorSubject<string>).next(transcription);
    }
    setTranscriptionInProgress(inProgress: boolean) {
        (this.transcriptionInProgress$ as BehaviorSubject<boolean>).next(inProgress);
    }
}